import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Corporatecabserviceinbelgaum() {



    const cardData = {




keyword: "Corporate Cab Services in Belgaum",

headingDescription: "Belgaum Taxi Service provides professional corporate cab services in Belgaum for businesses, IT companies, manufacturing industries, government organizations, educational institutions, hotels, and corporate offices. We offer reliable transportation solutions for employee pickup and drop, executive travel, client meetings, airport transfers, business conferences, factory visits, and long-term corporate travel requirements. Our fleet includes Sedan, Ertiga, SUV, Innova, Innova Crysta, Tempo Traveller, and premium vehicles to accommodate individual executives as well as large corporate teams. Every trip is managed by experienced chauffeurs, ensuring punctuality, comfort, and safety for business travelers. We also provide monthly billing, GST invoices, dedicated corporate booking support, flexible travel schedules, and customized transportation packages for organizations. Whether your employees need daily office transportation or your executives require intercity business travel, Belgaum Taxi Service delivers dependable corporate mobility solutions with well-maintained vehicles, transparent pricing, and 24/7 customer assistance for businesses across Belgaum and nearby cities.",

topPlaces: [
  {
    title: "Udyambag Industrial Area",
    description: "Udyambag is Belgaum's largest industrial estate, housing engineering companies, manufacturing units, and export businesses. It is one of the most preferred locations for daily corporate cab services."
  },
  {
    title: "Auto Nagar",
    description: "Auto Nagar is a prominent commercial and automobile business zone where corporate taxis are frequently booked for employee transportation, client meetings, and industrial visits."
  },
  {
    title: "KLE Technological University",
    description: "KLE Technological University attracts academic professionals, recruiters, corporate partners, and business visitors, making it a regular destination for executive cab services."
  },
  {
    title: "VTU Regional Office",
    description: "VTU is a major educational and administrative center visited by university officials, corporate recruiters, and business delegates throughout the year."
  },
  {
    title: "Angol",
    description: "Angol is a rapidly developing residential and commercial locality with offices, educational institutions, and business establishments requiring reliable taxi services."
  },
  {
    title: "Hubballi",
    description: "Hubballi is a major commercial city in Karnataka and a popular destination for corporate meetings, industrial visits, exhibitions, and business travel from Belgaum."
  },
  {
    title: "Kolhapur",
    description: "Kolhapur is an important business and manufacturing center frequently visited by corporate professionals for client meetings, factory visits, and commercial activities."
  },
  {
    title: "Pune",
    description: "Pune is one of India's leading IT and manufacturing hubs, making it a preferred destination for corporate travel, executive meetings, employee transfers, and business events."
  },
  {
    title: "Bengaluru",
    description: "Bengaluru is India's technology capital, home to multinational companies, business parks, and corporate headquarters. It is a popular route for executive and corporate cab bookings."
  },
  {
    title: "Goa",
    description: "Goa is not only a leisure destination but also hosts corporate conferences, exhibitions, business retreats, and company events, making it a frequent destination for executive travel."
  }
],




"services": [
  {
    "name": "Corporate Cab Services in Belgaum",
    "description": "Book Corporate Cab Services in Belgaum for reliable employee transportation, business meetings, airport transfers, executive travel, and daily office commute with professional chauffeurs and well-maintained AC vehicles."
  },
  {
    "name": "Corporate Taxi Service in Belgaum",
    "description": "Choose Corporate Taxi Service in Belgaum with Sedan, Ertiga, Innova Crysta, and SUV vehicles for safe, punctual, and comfortable business travel."
  },
  {
    "name": "Corporate Cab Service Belgaum",
    "description": "Hire Corporate Cab Service Belgaum with fixed pricing, monthly contracts, experienced drivers, and dedicated transportation solutions for companies."
  },
  {
    "name": "Corporate Car Rental Belgaum",
    "description": "Book Corporate Car Rental Belgaum for executive travel, client visits, conferences, office events, and airport transfers with premium chauffeur-driven vehicles."
  },
  {
    "name": "Business Cab Service Belgaum",
    "description": "Reserve Business Cab Service Belgaum for professional corporate travel with comfortable cars, transparent pricing, and flexible booking options."
  },
  {
    "name": "Employee Transportation Belgaum",
    "description": "Reliable Employee Transportation Belgaum with scheduled pickup and drop, GPS-enabled vehicles, trained drivers, and safe daily commuting."
  },
  {
    "name": "Office Cab Service Belgaum",
    "description": "Book Office Cab Service Belgaum for daily office commute, staff transportation, and corporate travel with punctual pickups and affordable pricing."
  },
  {
    "name": "Company Cab Service Belgaum",
    "description": "Choose Company Cab Service Belgaum for employee mobility, business travel, airport transfers, and corporate events with dedicated fleet support."
  },
  {
    "name": "IT Employee Cab Service Belgaum",
    "description": "Hire IT Employee Cab Service Belgaum for safe shift transportation, timely pickup and drop, and reliable daily office travel."
  },
  {
    "name": "Corporate Travel Solutions Belgaum",
    "description": "Get Corporate Travel Solutions Belgaum with customized transportation plans, executive cars, airport transfers, and long-term business travel services."
  },
  {
    "name": "Corporate Airport Transfer Belgaum",
    "description": "Book Corporate Airport Transfer Belgaum with flight tracking, professional chauffeurs, punctual pickup, and premium airport transportation."
  },
  {
    "name": "Executive Cab Service Belgaum",
    "description": "Travel with Executive Cab Service Belgaum featuring luxury vehicles, experienced chauffeurs, and premium comfort for business executives."
  },
  {
    "name": "Premium Corporate Cab Belgaum",
    "description": "Reserve Premium Corporate Cab Belgaum with luxury Sedan, SUV, and Innova Crysta vehicles for executive meetings and VIP transportation."
  },
  {
    "name": "Corporate Car Hire Belgaum",
    "description": "Book Corporate Car Hire Belgaum for flexible business travel, official visits, conferences, and client transportation with reliable service."
  },
  {
    "name": "Monthly Corporate Cab Service Belgaum",
    "description": "Choose Monthly Corporate Cab Service Belgaum with dedicated vehicles, fixed monthly plans, and reliable employee transportation."
  },
  {
    "name": "Daily Employee Pickup and Drop Belgaum",
    "description": "Book Daily Employee Pickup and Drop Belgaum with scheduled routes, experienced drivers, and comfortable AC vehicles for office commuting."
  },
  {
    "name": "Staff Transportation Belgaum",
    "description": "Reliable Staff Transportation Belgaum for factories, offices, IT companies, educational institutions, and industrial employees."
  },
  {
    "name": "Employee Shuttle Service Belgaum",
    "description": "Choose Employee Shuttle Service Belgaum with spacious vehicles, fixed schedules, and safe transportation for corporate staff."
  },
  {
    "name": "Corporate Cab Booking Belgaum",
    "description": "Complete Corporate Cab Booking Belgaum with instant confirmation, multiple vehicle options, and 24x7 customer support."
  },
  {
    "name": "Business Taxi Service Belgaum",
    "description": "Book Business Taxi Service Belgaum for professional meetings, airport transfers, executive travel, and corporate events."
  },
  {
    "name": "Airport Corporate Taxi Belgaum",
    "description": "Reserve Airport Corporate Taxi Belgaum with on-time airport pickup, luggage assistance, and premium chauffeur-driven vehicles."
  },
  {
    "name": "Luxury Corporate Cab Belgaum",
    "description": "Hire Luxury Corporate Cab Belgaum with Innova Crysta, premium SUVs, and executive Sedans for comfortable business travel."
  },
  {
    "name": "Sedan Corporate Cab Belgaum",
    "description": "Book Sedan Corporate Cab Belgaum for economical executive travel, client meetings, and airport transfers."
  },
  {
    "name": "Innova Crysta Corporate Cab Belgaum",
    "description": "Reserve Innova Crysta Corporate Cab Belgaum for executives, business teams, airport transfers, and premium outstation travel."
  },
  {
    "name": "Reliable Corporate Cab Belgaum",
    "description": "Choose Reliable Corporate Cab Belgaum with verified chauffeurs, clean vehicles, transparent pricing, and dependable corporate transportation."
  },
  {
    "name": "Best Corporate Cab Company Belgaum",
    "description": "Book with the Best Corporate Cab Company Belgaum for professional fleet management, business travel, and employee transport solutions."
  },
  {
    "name": "Corporate Fleet Services Belgaum",
    "description": "Get Corporate Fleet Services Belgaum with dedicated vehicles, customized travel plans, and efficient transportation management."
  },
  {
    "name": "IT Company Cab Service Belgaum",
    "description": "Reliable IT Company Cab Service Belgaum for employee shift transportation, office commute, and corporate travel."
  },
  {
    "name": "BPO Employee Transportation Belgaum",
    "description": "Book BPO Employee Transportation Belgaum with secure pickup and drop services, experienced drivers, and 24x7 availability."
  },
  {
    "name": "Factory Employee Transport Belgaum",
    "description": "Choose Factory Employee Transport Belgaum for daily workforce commuting with safe, comfortable, and punctual transportation."
  },
  {
    "name": "Industrial Employee Cab Service Belgaum",
    "description": "Hire Industrial Employee Cab Service Belgaum for manufacturing units, industrial estates, and corporate staff transportation."
  },
  {
    "name": "Corporate Event Transportation Belgaum",
    "description": "Book Corporate Event Transportation Belgaum for conferences, exhibitions, seminars, team outings, and business events with premium vehicles."
  },
  {
    "name": "Executive Business Travel Belgaum",
    "description": "Choose Executive Business Travel Belgaum for comfortable executive journeys, airport transfers, meetings, and VIP transportation."
  },
  {
    "name": "Employee Pick and Drop Services Belgaum",
    "description": "Book Employee Pick and Drop Services Belgaum with scheduled transportation, professional chauffeurs, GPS-enabled vehicles, and reliable daily office commute."
  }
],

"tableData": [
  ["Corporate Cab Services in Belgaum", "Corporate Taxi Service in Belgaum"],
  ["Corporate Cab Service Belgaum", "Corporate Car Rental Belgaum"],
  ["Business Cab Service Belgaum", "Employee Transportation Belgaum"],
  ["Office Cab Service Belgaum", "Company Cab Service Belgaum"],
  ["IT Employee Cab Service Belgaum", "Corporate Travel Solutions Belgaum"],
  ["Corporate Airport Transfer Belgaum", "Executive Cab Service Belgaum"],
  ["Premium Corporate Cab Belgaum", "Corporate Car Hire Belgaum"],
  ["Monthly Corporate Cab Service Belgaum", "Daily Employee Pickup and Drop Belgaum"],
  ["Staff Transportation Belgaum", "Employee Shuttle Service Belgaum"],
  ["Corporate Cab Booking Belgaum", "Business Taxi Service Belgaum"],
  ["Airport Corporate Taxi Belgaum", "Luxury Corporate Cab Belgaum"],
  ["Sedan Corporate Cab Belgaum", "Innova Crysta Corporate Cab Belgaum"],
  ["Reliable Corporate Cab Belgaum", "Best Corporate Cab Company Belgaum"],
  ["Corporate Fleet Services Belgaum", "IT Company Cab Service Belgaum"],
  ["BPO Employee Transportation Belgaum", "Factory Employee Transport Belgaum"],
  ["Industrial Employee Cab Service Belgaum", "Corporate Event Transportation Belgaum"],
  ["Executive Business Travel Belgaum", "Employee Pick and Drop Services Belgaum"]
],





whychoose: [
  {
    WhyChooseheading: "Professional Corporate Cab Services in Belgaum",
    WhyChoosedescription: "Belgaum Taxi Service provides reliable corporate cab solutions for businesses, IT companies, industrial visits, executive travel, and employee transportation with punctual and professional service."
  },
  {
    WhyChooseheading: "Dedicated Employee Transportation",
    WhyChoosedescription: "We offer daily employee pickup and drop services with flexible schedules, ensuring safe, comfortable, and on-time office commutes."
  },
  {
    WhyChooseheading: "Executive & Client Transfer Services",
    WhyChoosedescription: "Impress your clients and business associates with premium cab services for meetings, conferences, airport transfers, and corporate events."
  },
  {
    WhyChooseheading: "Modern Fleet for Business Travel",
    WhyChoosedescription: "Choose from Sedan, Ertiga, Innova, Innova Crysta, SUVs, Tempo Travellers, and premium vehicles to suit executive and team travel requirements."
  },
  {
    WhyChooseheading: "Experienced & Professional Chauffeurs",
    WhyChoosedescription: "Our trained drivers maintain professionalism, punctuality, and safety, ensuring a smooth travel experience for corporate employees and guests."
  },
  {
    WhyChooseheading: "Flexible Corporate Booking Plans",
    WhyChoosedescription: "We provide one-time bookings, daily office transport, monthly contracts, airport transfers, and customized corporate travel solutions." 
  },
  {
    WhyChooseheading: "Transparent Billing & Affordable Pricing",
    WhyChoosedescription: "Benefit from competitive corporate rates, transparent billing, and customized travel packages designed to meet your business transportation needs."
  },
  {
    WhyChooseheading: "24/7 Corporate Travel Support",
    WhyChoosedescription: "Our dedicated support team is available around the clock for urgent bookings, schedule changes, airport pickups, and business travel assistance."
  }
]

};

const faqData = [
  {
    question: "Does Belgaum Taxi Service provide corporate cab services in Belgaum?",
    answer: "Yes, we offer corporate cab services for employee transportation, executive travel, client meetings, airport transfers, and business events."
  },
  {
    question: "Can I book daily employee pickup and drop services?",
    answer: "Yes, we provide daily employee transportation with flexible pickup schedules and dedicated vehicles for companies."
  },
  {
    question: "Do you provide airport transfers for corporate clients?",
    answer: "Yes, we offer timely airport pickup and drop services for business executives, employees, and corporate guests."
  },
  {
    question: "Which vehicles are available for corporate travel?",
    answer: "Our fleet includes Sedan, Ertiga, Innova, Innova Crysta, SUVs, Tempo Travellers, and premium vehicles for executive and group travel."
  },
  {
    question: "Can I hire cabs for corporate meetings and events?",
    answer: "Yes, we provide transportation for business meetings, conferences, seminars, exhibitions, and corporate events."
  },
  {
    question: "Do you offer monthly corporate cab contracts?",
    answer: "Yes, customized monthly and long-term corporate transportation plans are available for businesses and organizations." 
  },
  {
    question: "Is corporate cab service available 24/7?",
    answer: "Yes, our corporate taxi services operate 24 hours a day for office shifts, airport transfers, and business travel."
  },
  {
    question: "Do you provide GST invoices for corporate bookings?",
    answer: "Yes, GST invoices and transparent billing are available for eligible corporate bookings and business accounts."
  },
  {
    question: "Can I arrange transportation for corporate groups?",
    answer: "Yes, we provide spacious vehicles and Tempo Travellers for team outings, employee groups, and corporate events."
  },
  {
    question: "How can I book Corporate Cab Services in Belgaum?",
    answer: "Share your company name, pickup location, destination, travel schedule, passenger details, and preferred vehicle to receive a customized quotation and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Amit Kulkarni",
    feedback: "Belgaum Taxi Service has been managing our executive travel efficiently. The vehicles are always clean, drivers are professional, and every pickup is punctual.",
    rating: 5
  },
  {
    id: 2,
    name: "Ms. Shreya Patil",
    feedback: "We booked corporate cabs for employee transportation, and the service exceeded our expectations. Reliable scheduling, courteous chauffeurs, and comfortable vehicles made daily commuting effortless.",
    rating: 5
  }
];






    const Images = [
        { place: "/images/keyword/1.jpg", text: "Cab Service in Belgaum", link: "Cab-Service-in-Belgaum" },
        { place: "/images/keyword/2.jpg", text: "Belgaum Taxi Service", link: "Belgaum-Taxi-Service" },
        { place: "/images/keyword/3.jpg", text: "Belgaum to Goa Cab", link: "Belgaum-to-Goa-Cab" },
        { place: "/images/keyword/4.jpg", text: "Belgaum to Mahabaleshwar Cab", link: "Belgaum-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/5.jpg", text: "Belgaum to Kerala Cab Service", link: "Belgaum-to-Kerala-Cab-Service" },
        { place: "/images/keyword/6.jpg", text: "Goa to Belgaum Cab", link: "Goa-to-Belgaum-Cab" },
        { place: "/images/keyword/7.jpg", text: "Belgaum to Mumbai Cab", link: "Belgaum-to-Mumbai-Cab" },
        { place: "/images/keyword/8.jpg", text: "Belgaum to Bangalore Cab", link: "Belgaum-to-Bangalore-Cab" },
        { place: "/images/keyword/9.jpg", text: "Goa Cab Service", link: "Goa-Cab-Service" },
        { place: "/images/keyword/10.jpg", text: "Taxi Service in Goa", link: "Taxi-Service-in-Goa" },
        { place: "/images/keyword/11.jpg", text: "Cheapest Cab Service in Goa", link: "Cheapest-Cab-Service-in-Goa" },
        { place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Belgaum", link: "Corporate-Cab-Services-in-Belgaum" },
        { place: "/images/keyword/13.jpg", text: "Innova Crysta Rent in Belgaum", link: "Innova-Crysta-Rent-in-Belgaum" },
        { place: "/images/keyword/14.jpg", text: "Ertiga on Rent in Belgaum", link: "Ertiga-on-Rent-in-Belgaum" },
        { place: "/images/keyword/15.jpg", text: "Tempo Traveller Rent in Belgaum", link: "Tempo-Traveller-Rent-in-Belgaum" },
        { place: "/images/keyword/16.jpg", text: "Mini Bus Rental Belgaum", link: "Mini-Bus-Rental-Belgaum" },
        { place: "/images/keyword/17.jpg", text: "Swift Dzire on Rent in Belgaum", link: "Swift-Dzire-on-Rent-in-Belgaum" },
        { place: "/images/keyword/18.jpg", text: "Urbania on Rent in Belgaum", link: "Urbania-on-Rent-in-Belgaum" },
        { place: "/images/keyword/19.jpg", text: "Wedding Car Rental in Belgaum", link: "Wedding-Car-Rental-in-Belgaum" },
        { place: "/images/keyword/20.jpg", text: "Cabs in Belgaum", link: "Cabs-in-Belgaum" },
        { place: "/images/keyword/21.jpg", text: "Belgaum to Hubli Cab", link: "Belgaum-to-Hubli-Cab" },
        { place: "/images/keyword/22.jpg", text: "Belgaum to Dharwad Cab", link: "Belgaum-to-Dharwad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Belgaum to Kolhapur Cab", link: "Belgaum-to-Kolhapur-Cab" },
        { place: "/images/keyword/24.jpg", text: "Belgaum Airport Cab Service", link: "Belgaum-Airport-Cab-Service" },
        { place: "/images/keyword/25.jpg", text: "Belgaum to Bagalkot Cab", link: "Belgaum-to-Bagalkot-Cab" },
    ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Cab Services in Belgaum",
  "image": "https://www.belgaumtaxiservice.com/assets/images/corporate-cab-services-in-belgaum.webp",
  "description":
    "Book Corporate Cab Services in Belgaum with Belgaum Taxi Service for reliable employee transportation, business travel, and office cab solutions. We provide corporate taxi services for companies, IT employees, meetings, and daily office commutes with Sedan, Ertiga, SUV, Innova, and premium cab options available 24x7.",
  "brand": {
    "@type": "Brand",
    "name": "Belgaum Taxi Service"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.belgaumtaxiservice.com/corporate-cab-services-in-belgaum"
  }
};






    return (
        <div>
<Helmet>
  <title>Corporate Cab Services in Belgaum | Office Taxi | +91 8722158435</title>

  <meta
    name="description"
    content="Book Corporate Cab Services in Belgaum with Belgaum Taxi Service for employee transportation, office travel, business meetings, and company cab requirements. Get professional corporate taxi solutions with Sedan, Ertiga, SUV, Innova, and premium cabs available 24x7."
  />

  <meta
    name="keywords"
    content="Corporate Cab Services in Belgaum, Corporate Taxi Service in Belgaum, Corporate Cab Service Belgaum, Corporate Car Rental Belgaum, Business Cab Service Belgaum, Employee Transportation Belgaum, Office Cab Service Belgaum, Company Cab Service Belgaum, IT Employee Cab Service Belgaum, Corporate Travel Service Belgaum, Corporate Taxi Booking Belgaum"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>







            <div className="page-headder bg-section parallaxie">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="page-header-box text-white">
                                <h1 className="text-anime-style-3 text-center text-white">
                                    {cardData.keyword}
                                </h1>
                            </div>
                        </div>
                    </div>
                </div>
            </div>













            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/12.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Belgaum Taxi Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            {/* <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                  
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div> */}


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Belgaum Taxi Service</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Belgaum Taxi Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918722158435 " className="pc-call">+91 8722158435 </a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/918722158435 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918722158435 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@belgaumtaxiservice.com" className="pc-email">
                                            booking@belgaumtaxiservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Belgaum Taxi Service</strong><br />
                                            P No 30 cCTS No 7023,
                                            Sector No 9 Malmaruti Anjaneya Nagar,
                                            Belgaum, Karnataka - 590017




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Corporatecabserviceinbelgaum;